import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import Typography from '@mui/material/Typography';

import AcaoMenu from "../../Components/AcaoMenu";
import { ApplicationState } from "../../store";

import * as DestaqueActions from '../../store/ducks/destaque/actions'
import Loading from "../../Components/LoadingComponent";
import DestaqueTableComponent from "../../Components/TableDestaque";
import ModalCadastroDestaque from "../../Components/ModalCadastroDestaque";
import AlertaConfirmaAcao from "../../Components/AlertaConfirmaAcao";
import { EntidadesAcoes } from "../../config/enums/EntidadesAcoesConfirmacao";

const _body = {
    pagina: 0,
    tamanho: 10,
    ordem: "ASC",
    coluna: "dsDestaque",
    txtBusca: "",
};

function Destaque({
    destaque,
    getDestaqueTable,
    onInativarDestaque,
    getDestaqueData,
    onSaveDestaque,
    onUpdateDestaque,
    clearDestaqueData
}: any) {

    const [idsSelecionado, setIdSelecionado] = useState<number[]>([]);
    const [modalCadastroOpen, setModalCadastroOpen] = useState(false);
    const [body, setBody] = useState(_body);
    const [table, setTable] = useState(null);
    const [alertConfirmacaoOpen, setAlertConfirmacaoOpen] = useState(false);
    const [alertConfirmacaoTexto, setAlertConfirmacaoTexto] = useState('');
    const [alertConfirmacaoAcao, setAlertConfirmacaoAcao] = useState(() => () => {});

    useEffect(() => {
        if(destaque.error){
            alert('Erro!\nAtenção, ocorreu um erro durante sua solicitação. Caso apareça essa mensagem novamente procure o Suporte:\nDescrição do erro: ' + destaque.errorMessage);
        }
    }, [destaque.error]);

    useEffect(() => {
        if(!destaque.loadingPersis) {
            handleCloseAndReload()
        }
    }, [destaque.loadingPersis]);

    useEffect(() => {
        if(!modalCadastroOpen) {
            getDestaqueTableData();
        }
    }, [body, modalCadastroOpen]);

    useEffect(() => {
        if(destaque.data.table != null){
            setTable(destaque.data.table);
        }

    }, [destaque.data]);

    useEffect(() => {
        if(!destaque.loadingInativacao){
            getDestaqueTable(body);
        }
    }, [destaque.loadingInativacao]);

    const getDestaqueTableData = () => {
        getDestaqueTable(body);
    }

    const handleCadastro = () => {
        clearDestaqueData();
        setModalCadastroOpen(true)
    }

    const handleEdicao = () => {
        if(idsSelecionado.length == 0) {
            alert('Selecione um destaque que gostaria de alterar');

        } else if(idsSelecionado.length > 1) {
            alert('Selecione apenas um destaque para alteração!');

        } else {
            getDestaqueData(idsSelecionado[0]);
            setModalCadastroOpen(true);
        }
    }

    const handleInativacao = () => {
        if(idsSelecionado.length == 0) {
            alert('Selecione os destaques que gostaria de excluir');
        } else {
            setAlertConfirmacaoOpen(true);
            setAlertConfirmacaoTexto(EntidadesAcoes.DESTAQUES_EXCLUSAO);
            setAlertConfirmacaoAcao(() => () => {
                onInativarDestaque(idsSelecionado);
                setAlertConfirmacaoOpen(false);
            })
        }
    }

    const changeTable = (__body: any) => {
        setBody({...__body});
    }

    const handlePersistDestaque = (edicao: boolean, destaque: FormData) => {
        if(edicao) {
            onUpdateDestaque(destaque);
        } else {
            onSaveDestaque(destaque);
        }

    }

    const handleCloseAndReload = () => {
        clearDestaqueData();
        setModalCadastroOpen(false);
        setIdSelecionado([]);
    }

    const unmountAlertConfirmacao = () => {
        setAlertConfirmacaoTexto('');
        setAlertConfirmacaoAcao(() => () => {})
        setAlertConfirmacaoOpen(false);
    }

    return (
        <div className="pageBox">
            <Loading loading={destaque.loading || destaque.loadingPersis} />
            <AlertaConfirmaAcao openDialog={alertConfirmacaoOpen} texto={alertConfirmacaoTexto} execAcao={() => alertConfirmacaoAcao()} cancelaAcao={() => unmountAlertConfirmacao()} />
            <ModalCadastroDestaque 
                modalCadastroOpen={modalCadastroOpen} 
                closeModal={() => handleCloseAndReload()}
                destaqueData={destaque.data.destaque} 
                persist={handlePersistDestaque}
                listDestaqueTipo={destaque.data.destaqueTipo}
            />
            <div className="menuLateral">
                <Typography variant="h6" noWrap component="div" sx={{
                    width: '100%'
                }} >
                    Ações
                    <AcaoMenu
                        onCadastro={handleCadastro} 
                        onEditar={handleEdicao} 
                        onInativar={handleInativacao} 
                    />
                </Typography>
            </div>
            <div className="table">
                <DestaqueTableComponent
                    loading={destaque.loadingTable} 
                    data={table} 
                    body={body}
                    onChange={changeTable} 
                    selection={idsSelecionado}
                    idSelectionChange={(idsArr: number[]) => setIdSelecionado(idsArr)}/>
            </div>
        </div>
    )
};

const mapStateToProps = (state: ApplicationState) => ({
    destaque: state.destaque,
    utils: state.utils
});
  
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({...DestaqueActions}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Destaque);
